<template>
  <div class='app-container'>

    <el-form :model='queryParams' ref='queryForm' size='small' :inline='true' v-show='showSearch'>
      <el-form-item label='类型' prop='status'>
        <el-select v-model='queryParams.type' placeholder='请选择' clearable>
          <el-option clearable v-for='item in options' :key='item.value' :label='item.label' :value='item.value'>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label='满意度' prop='satisficing'>
        <el-select v-model='queryParams.satisficing' placeholder='请选择' clearable>
          <el-option clearable  label='满意' value='满意'></el-option>
          <el-option clearable  label='基本满意' value='基本满意'></el-option>
          <el-option clearable  label='不满意' value='不满意'></el-option>
          <el-option clearable  label='不了解' value='不了解'></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type='primary' icon='el-icon-search' size='mini' @click='handleQuery'>搜索</el-button>
        <el-button icon='el-icon-refresh' size='mini' @click='resetQuery'>重置</el-button>
      </el-form-item>
      <el-form-item style='float: right;'>
        <el-button type='primary' size='mini' @click='exportExcel'>导出</el-button>
      </el-form-item>
    </el-form>

    <table id='excel' style='display: none;'>
    </table>
    <el-table :data='shlist' :span-method='arraySpanMethod'
              @selection-change='handleSelectionChange' v-loading='listloading' border style='width: 100%'>
      <el-table-column type='selection' width='40' fixed='left'>
      </el-table-column>

      <el-table-column prop='type' label='调查方面 ' width='80'></el-table-column>
      <el-table-column prop='satisficing' label='满意度' width='80'></el-table-column>
      <el-table-column prop='reason' label='问题原因 ' :show-overflow-tooltip='true'>
      </el-table-column>
      <el-table-column prop='desc' label='问题描述' :show-overflow-tooltip='true'>
      </el-table-column>
      <el-table-column prop='username' label='用户姓名' width='100' :show-overflow-tooltip='true'></el-table-column>
      <el-table-column prop='userphone' label='用户电话' width='120'></el-table-column>
      <el-table-column prop='region' label='所属街镇' width='100'></el-table-column>
      <el-table-column fixed='right' label='操作' width='60'>
        <template slot-scope='scope'>
          <el-button type='text' size='mini' @click='handleDelete(scope.$index, scope.row)'>删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination v-show='total > 0' :total='total' :page.sync='queryParams.page' :limit.sync='queryParams.pagesize'
                @pagination='fetchList' />

    <!--    <div class='block' style='margin-top:20px;'>
          <el-pagination align='center' @size-change='handleSizeChange' @current-change='handleCurrentChange'
                         :current-page='currentPage' :page-sizes='[5,10, 15, 20, 30, 45, 50, 100]' :page-size='pageSize'
                         layout='total, sizes, prev, pager, next, jumper' :total='total'>
          </el-pagination>
        </div>-->
  </div>
</template>

<script>
// @ts-nocheck
import * as XLSX from 'xlsx'
import { queryCompanyRiskMaps, deletes } from '../api/list'

export default {
  data() {
    return {

      listloading: false,
      tableData: [],
      showSearch: true,
      shlist: [],
      total: 0,

      locationList: [],
      queryParams: {
        type: '',
        keyword: '',
        satisficing: '',
        page: 1,
        pagesize: 15
      },
      currentPage: 1, // 当前页码
      pageSize: 10,// 每页的数据条数

      multipleSelection: [],
      multipleSelectionData: [],

      dialogFormVisible: false,
      dialogStatus: '',
      tableTitleData: [
        {
          title: '调查方面',
          key: 'type'
        },
        {
          title: '满意度',
          key: 'satisficing'
        },
        {
          title: '问题原因',
          key: 'reason'
        },
        {
          title: '问题描述',
          key: 'desc'
        },
        {
          title: '用户姓名',
          key: 'username'
        },
        {
          title: '用户电话',
          key: 'userphone'
        },
        {
          title: '所属街镇',
          key: 'region'
        },
        {
          title: '提交时间',
          key: 'createtime'
        }
      ],
      options: [{
        value: '居住环境',
        label: '居住环境'
      }, {
        value: '社会治安',
        label: '社会治安'
      }, {
        value: '基本医疗',
        label: '基本医疗'
      }, {
        value: '文体活动',
        label: '文体活动'
      }, {
        value: '基础教育',
        label: '基础教育'
      }, {
        value: '社会帮扶',
        label: '社会帮扶'
      }
      ],
      value: '',
      lb: '列表'
    }
  },
  created() {
    this.fetchList()
  },
  methods: {
    handleSizeChange(val) {
      this.currentPage = 1
      this.pageSize = val
    },
    handleCurrentChange(val) {
      this.currentPage = val
    },
    handleDelete(index, row) {
      let that = this;
      let _index = this.locationList.findIndex(v=>v.id==row.id)
      this.$confirm('确定要删除此条内容吗?', '提示', {
        confirmButtonText: '确定',

        type: 'warning'
      }).then(() => {
        deletes({ id: row.id }).then(res => {
          that.$notify({
            title: '成功',
            message: '删除成功',
            type: 'success',
            duration: 2000
          })
          that.locationList.splice(_index, 1)
          that.createTableData()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    //  导出
    exportExcel() {
      if (this.multipleSelection.length < 1) {
        this.$message('请选择需要导出的列表')
      } else {
        this.lb = '调查反馈' + this.queryParams.type
        const data = XLSX.utils.table_to_sheet(document.getElementById('excel'))
        console.log(data)
        const sheet = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(sheet, data, '列表')
        XLSX.writeFile(sheet,this.lb + '.xlsx')
        //  export2Excel(this.tableTitleData, this.multipleSelectionData, this.lb)
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
      this.multipleSelectionData = []
      let arr = []
      this.multipleSelection.forEach(k => {
        if (k.rows) {
          arr.push(k.index)
        }
      })
      //  处理合并单元格导致的multiple内容缺失
      arr.forEach(m => {
        this.shlist.forEach(v => {
          if (v.index == m) {
            this.multipleSelectionData.push(v)
          }
        })
      })
      //  ------------------------------
      let el = document.getElementById('excel')
      el.innerHTML = '<tr>\n' +
        '        <td>调查方面</td>\n' +
        '        <td>满意度</td>\n' +
        '        <td>问题原因</td>\n' +
        '        <td>问题描述</td>\n' +
        '        <td>用户姓名</td>\n' +
        '        <td>用户电话</td>\n' +
        '        <td>所属街镇</td>\n' +
        '        <td>提交时间</td>\n' +
        '      </tr>'

      this.multipleSelectionData.forEach((n, l) => {
        if (n.rows) {
          let tr = document.createElement('tr')
          this.tableTitleData.forEach((p, q) => {
            let td = document.createElement('td')
            if (q != 2 && q != 3 ) {
              td.setAttribute('rowspan', n.rows)
            }
            if (n[p.key]) {
              td.innerText = n[p.key]
            }
            tr.append(td)

          })
          el.append(tr)
        } else {
          let tr = document.createElement('tr');
          ['reason', 'desc'].forEach(p => {
            let td = document.createElement('td')
            if (n[p]) {
              td.innerText = n[p]
            }

            tr.append(td)
          })
          el.append(tr)
        }
      })
    },

    handleQuery() {
      this.queryParams.page = 1
      this.fetchList()
    },
    resetQuery() {
      this.queryParams.keyword = undefined
      this.queryParams.satis = undefined
      this.handleQuery()
    },
    fetchList() {
      this.listloading = true
      queryCompanyRiskMaps(this.queryParams).then(res => {
        this.locationList = res.data
        this.shlist = []
        this.locationList.forEach((k, index) => {

          if (k.cases) {
            k.cases.forEach((j, keys) => {

              /*重建数据*/
              if (keys == 0) {
                let oo = JSON.parse(JSON.stringify(k))
                    oo.reason = j.casz
                    oo.desc = j.desc
                    oo.rows = k.cases.length
                    oo.index = index
                this.shlist.push(oo)
              } else {
                let ob = JSON.parse(JSON.stringify(k))
                for (let a in ob) {
                  ob[a] = null
                }
                ob.index = index
                ob.reason = j.casz
                ob.desc = j.desc
                this.shlist.push(ob)
              }
            })
          } else {
            let oc = JSON.parse(JSON.stringify(k))
                oc.rows = 1
                oc.index = index
            this.shlist.push(oc)
          }
        })
        this.total = res.pageInfo.total
        this.listloading = false
      })
    },
    createTableData(){
      this.shlist = []
      this.locationList.forEach((k, index) => {
        if (k.cases) {
          k.cases.forEach((j, keys) => {

            /*重建数据*/
            if (keys == 0) {
              let oo = JSON.parse(JSON.stringify(k))
              oo.reason = j.casz
              oo.desc = j.desc
              oo.rows = k.cases.length
              oo.index = index
              this.shlist.push(oo)
            } else {
              let ob = JSON.parse(JSON.stringify(k))
              for (let a in ob) {
                ob[a] = null
              }
              ob.index = index
              ob.reason = j.casz
              ob.desc = j.desc
              this.shlist.push(ob)
            }
          })
        } else {
          let oc = JSON.parse(JSON.stringify(k))
          oc.rows = 1
          oc.index = index
          this.shlist.push(oc)
        }
      })
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex < 3 || columnIndex > 4) {
        if (row.rows) {
          return [row.rows, 1]
        } else {
          return [0, 0]
        }
      }
    }
  }
}
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
